module.exports = __webpack_public_path__ + "static/media/wojak.a15aec91.jpg";